import { MAX_PAGE_SIZE, pageOf } from '@britania/teams-kit-core';
import { z } from 'zod';
import { pendingApprovalTicketSchema } from '#src/tickets/pending-approval-tickets.contract.js';
/** Uma pessoa que receberia lembrete, com quantos chamados em cada papel. */
export const reminderRecipientSchema = z.strictObject({
    email: z.string(),
    name: z.string().nullable(),
    /** Chamados aguardando a aprovação desta pessoa. */
    approverTickets: z.int().nonnegative(),
    /** Chamados que esta pessoa abriu e aguardam aprovação. */
    requesterTickets: z.int().nonnegative(),
});
export const reminderRecipientsPageSchema = pageOf(reminderRecipientSchema);
/**
 * Chamados a partir dos quais enviar lembretes. Tem a mesma forma da resposta
 * de `GET /tickets/pending-approval`, para que ela possa ser colada aqui; os
 * campos de paginação são aceitos e ignorados.
 */
export const sendRemindersRequestSchema = z.strictObject({
    items: z.array(pendingApprovalTicketSchema).min(1).max(MAX_PAGE_SIZE),
    page: z.number().optional(),
    pageSize: z.number().optional(),
    totalItems: z.number().optional(),
    totalPages: z.number().optional(),
});
/** Por que envios falharam, sem repetir: cada motivo com quantos derrubou. */
export const deliveryFailureSchema = z.strictObject({
    reason: z.string(),
    count: z.int().positive(),
});
export const sendRemindersResponseSchema = z.strictObject({
    /** Cards entregues. */
    sent: z.int().nonnegative(),
    /** Cards que falharam. */
    failed: z.int().nonnegative(),
    /** Motivos das falhas; o detalhe técnico de cada uma está no log. */
    failures: z.array(deliveryFailureSchema),
    /** Pessoas dos chamados sem e-mail, que ficaram sem lembrete. */
    peopleWithoutEmail: z.int().nonnegative(),
});
/** Qual versão do lembrete: a do aprovador ou a do solicitante. */
export const reminderAudienceSchema = z.enum(['approver', 'requester']);
/**
 * O que uma pessoa recebe na próxima execução: um card por papel, com o JSON
 * exato que vai ao Teams, para a administração renderizar a prévia.
 */
export const recipientCardsSchema = z.strictObject({
    email: z.string(),
    name: z.string().nullable(),
    cards: z
        .array(z.strictObject({
        audience: reminderAudienceSchema,
        /** Texto da notificação do Teams. */
        summary: z.string(),
        /** JSON do Adaptive Card. */
        card: z.record(z.string(), z.unknown()),
    }))
        .min(1),
});
/** Resultado de enviar os cards de uma pessoa, a ela ou a quem pediu a prévia. */
export const cardsSendResponseSchema = z.strictObject({
    /** Quem recebeu os cards. */
    sentTo: z.string(),
    sent: z.int().nonnegative(),
    failed: z.int().nonnegative(),
    failures: z.array(deliveryFailureSchema),
});
//# sourceMappingURL=reminders.contract.js.map